import { List } from 'antd'
import { ListItemProps as AntdListItemProps } from 'antd/lib/list/Item'

export type ListItemProps = AntdListItemProps

export const ListItem = List.Item
